<template>
  <dialogTemplate
    :openDialog="isOpen"
    :widthDialog="'1000px'"
    :classDialog="'dialog-doc-out-finish'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
  >
    <template #body>
      <div v-bind:style="classObject">
        <!--        <h3 class="dialogTitle">Cho ý kiến</h3>-->
        <div class="">
          <el-form
            label-position="top"
            ref="form"
            :model="form"
            class="phieuYKien-input"
            :rules="validationRules"
          >
            <el-form-item prop="content">
              <el-input
                class="inputForm"
                v-model="form.content"
                type="textarea"
                placeholder="Ý kiến chỉ đạo"
                rows="10"
                maxlength="2200"
              />
            </el-form-item>
          </el-form>
        </div>
      </div>
    </template>
    <template #footer>
      <div class="flex-row flex__right form-button__action">
        <el-button
          class="dialogBtnPrimary"
          @click="choYKien"
          :disabled="isProcessing"
        >
          <i
            :class="[
              !isProcessing
                ? 'fas fa-check-circle font-size__small'
                : 'el-icon-loading'
            ]"
          ></i>
          Xác nhận & ký số
        </el-button>
        <el-button
          class="btn__cancel btn-none__border"
          @click="$emit('closeDialog')"
        >
          <i class="fal fa-times"></i>
          &nbsp;Hủy
        </el-button>
      </div>
    </template>
  </dialogTemplate>
</template>
<script>
  import vbIncomingProcessService from "../../../services/vbIncomingProcessService";
  import handleRequestErrorMixin from "../../handleRequestErrorMixin";
  import vbAttachmentTokenService from "../../../services/vbAttachmentTokenService";
  import vbOpinionFormService from "../../../services/vbOpinionFormService";
  import buildAttachmentImage from "../../../filters/buildAttachmentImage";
  import constants from "../../../constants";

  export default {
    name: "ChoYKienDialog",
    mixins: [handleRequestErrorMixin],
    props: ["isOpen", "vbIncomingId", "processId", "vbOutgoingDocId"],
    components: {
      dialogTemplate: () => import("../../common/custom-dialog.vue")
    },

    data() {
      return {
        backgroundImage: null,
        isProcessing: false,
        token: null,
        form: {content: null},
        validationRules: {
          content: [
            {
              required: true,
              message: "Trường dữ liệu bắt buộc",
              trigger: "blur"
            }
          ]
        }
      };
    },

    computed: {
      userDeptRoleId() {
        return this.$route.params.userDeptRoleId;
      },
      parentRoute() {
        return this.$route.path.split("/")[3];
      },
      classObject() {
        return {
          "background-image": `url("${this.backgroundImage}")`,
          "height": "1100px",
          "background-position": "center",
          "background-repeat": "no-repeat",
          "background-size": "contain",
          "padding-top": "400px"
        };
      }
    },

    created() {
      this.loadBackground();
    },

    methods: {
      loadBackground() {
        if (!this.vbIncomingId) return;
        return vbOpinionFormService
          .findByDocIdAndUser(this.vbOutgoingDocId, this.userDeptRoleId)
          .then(response => {
            let mineOpinionForm = response.data;
            if (mineOpinionForm) {
              vbAttachmentTokenService
                .getToken(mineOpinionForm.attachDocumentId)
                .then(response2 => {
                  this.token = response2.data.token;
                  this.backgroundImage = buildAttachmentImage(this.token, {
                    type: constants.DOWNLOAD_OPTION.TYPE.IMAGE,
                    imageStatus: "original",
                    pageNumber: 0
                  });
                });
            }
          });
      },

      backModel() {
        this.$router.push({name: this.parentRoute, params: this.$route.params});
      },

      choYKien() {
        this.$refs.form.validate(valid => {
          if (!valid) {
            this.notify("Lỗi", "Có lỗi nhập liệu !", "error", 2000);
          } else {
            this.isProcessing = true;
            let submitForm = {
              incomingProcessId: this.processId,
              content: this.form.content
            };
            vbIncomingProcessService
              .choYKien(submitForm, this.vbIncomingId)
              .then(() => {
                this.isProcessing = false;
                this.$emit("success", {});
              })
              .catch(error => {
                this.isProcessing = false;
                let makeError = JSON.parse(JSON.stringify(error))
                if(makeError.response && makeError.response.data && makeError.response.data.errors && makeError.response.data.errors.length > 0) {
                  makeError.response.data.errors.forEach(errorData => {
                    errorData.errorCode = errorData.params[0]
                  })
                }
                this.commonHandleRequestError(makeError);
                throw error;
              });
          }
        });
      }
    }
  };
</script>
<style scoped>
  .inputForm {
    font-family: "Times New Roman", serif;
    font-size: 16px;
  }

  .phieuYKien .phieuYKien-input {
    /*margin-top: 200px;*/
  }
</style>



// WEBPACK FOOTER //
// src/views/doc-in/components/ChoYKienDialog.vue